import { createSelector } from '@ngrx/store';
import { getOneClickState } from '@ordersnproducts/modules/one-click-order/reducers';

export const getOneClickOwnFreightPlantsState = createSelector(
  getOneClickState,
  state => state.ownFreightPlantsState,
);

export const getOneClickOwnFreightPlants = createSelector(
  getOneClickOwnFreightPlantsState,
  state => state.ownFreightPlantsAvailable,
);

export const getOneClickOwnFreightPlantSelected = createSelector(
  getOneClickOwnFreightPlantsState,
  state => state.selected,
);
